import apiClient from "./index";
import { getGlobalStore } from '../../views/pages/AppStore';

export const logOutProc = () => {
    const store = getGlobalStore(); // 전역 스토어 가져오기
    return apiClient.post(`/sso/mbr/logout.json`, {}, {
        headers: {
            'refresh': store.state.refresh
        }
    });
}